import React, { Component } from 'react'
import AppContext from "@lightspeed-invoicing/core-client/frontend/app/Context";
import { FormattedDate, FormattedMessage, FormattedRelative } from "react-intl";
import { SingleDatePicker } from "react-dates";
const uuidv4 = require('uuid/v4')
import moment from "moment-timezone"
import Icon from "../common/icon/icon.component.jsx";

class InvoiceDueDate extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            dueDate: moment(this.props.value || ''),
            currentDate: this.props.value || '',
            status: this.props.status || '',
            relative: this.props.relative || false,
            dateOnly: this.props.dateOnly || false,
            invoiceId: this.props.invoiceId || null,
            uniqueId: uuidv4(),
            editable: this.props.editable || false,
            editMode: false,
            hover: false,
            onChange: this.props.onChange || function () { },
        }
        this.triggerEdit = this.triggerEdit.bind(this)
        this.onSave = this.props.onSave || function () { }
        this.save = this.save.bind(this)
        this.onMouseEnterHandler = this.onMouseEnterHandler.bind(this)
        this.onMouseLeaveHandler = this.onMouseLeaveHandler.bind(this)
    }


    componentWillReceiveProps(nextProps) {
        this.setState({
            dueDate: moment(nextProps.value || ''),
            currentDate: nextProps.value || '',
            status: nextProps.status || '',
            invoiceId: nextProps.invoiceId || null,
        })
    }

    componentDidMount() { }

    onMouseEnterHandler() {
        this.setState({
            hover: true
        });
    }

    onMouseLeaveHandler() {
        this.setState({
            hover: false
        });
    }

    triggerEdit(event) {
        event?.preventDefault()
        this.setState({
            editMode: !this.state.editMode
        })
    }

    save(event) {
        event.preventDefault()
        AppContext.getApiClient().patch('/invoices/' + this.state.invoiceId, {
            dueDate: this.state.dueDate.format(),
        }).then((r) => {
            this.onSave(this.state.dueDate.format())
            this.setState({
                currentDate: r.attributes.dueDate,
                editMode: false,
            })
        })
    }

    isLate() {
        const now = moment().startOf('day').toDate()
        const dueDate = new Date(this.state.currentDate)
        return !['fully-paid', 'voided'].includes(this.state.status) && now > dueDate
    }

    render() {
        if (!this.state.dueDate) {
            return ''
        }

        let dueDate = <FormattedDate
            year='numeric'
            month='long'
            day='numeric'
            value={new Date(this.state.currentDate)} />

        if (this.state.relative) {
            dueDate = <FormattedRelative value={new Date(this.state.currentDate)} />
        }

        if (this.isLate()) {
            dueDate = <span>
                <FormattedDate
                    year='numeric'
                    month='long'
                    day='numeric'
                    value={new Date(this.state.currentDate)}
                />
                <span className={"text-danger ml-1"}>
                    <small>
                        <Icon value={"exclamation"} />
                        <FormattedMessage
                            id="invoice.due_date.due_on_label"
                            defaultMessage="Due {date}"
                            values={{
                                date: <FormattedRelative value={new Date(this.state.currentDate)} />
                            }}
                        />
                    </small>
                </span>
            </span>
            if (this.state.relative) {
                dueDate = <span className={"text-danger ml-1"}>
                    <FormattedRelative value={new Date(this.state.currentDate)} />
                </span>
            }
            if (this.state.dateOnly) {
                dueDate = <span className={"text-danger"}>
                    <FormattedDate
                        year='numeric'
                        month='long'
                        day='numeric'
                        value={new Date(this.state.currentDate)}
                    />
                </span>
            }
        }

        if (this.state.editable) {
            let link = <a href={'#'} onClick={this.triggerEdit} onMouseEnter={this.onMouseEnterHandler} onMouseLeave={this.onMouseLeaveHandler}>
                {dueDate} <Icon value={'pencil-alt'} className={'ml-1 ' + (!this.state.hover ? 'text-gray' : '')} />
            </a>
            dueDate = <span>
                {link}
                <div className={"dropdown-menu p-4 col-md-4 " + (this.state.editMode ? 'show' : '')}
                    style={{ minWidth: '250px' }}>
                    <div className="w-100 m-0">
                        <SingleDatePicker
                            small
                            block
                            displayFormat="LL"
                            focused={this.state.focused}
                            isOutsideRange={() => false}
                            onDateChange={(date) => {
                                this.setState({
                                    dueDate: date
                                })
                            }}
                            onFocusChange={({ focused }) => this.setState({ focused })}
                            date={this.state.dueDate}
                            numberOfMonths={1}
                            id={'dueDate'}
                        />
                    </div>
                    <p className="m-0 pt-2">
                        <button className="btn btn-sm btn-outline-secondary" onClick={this.triggerEdit}>
                            <Icon value={"arrow-left"} />
                        </button>
                        <button className="btn btn-sm btn-outline-primary ml-2" onClick={this.save}>
                            <Icon value={"save"} />
                        </button>
                    </p>
                </div>
            </span>
        }

        return dueDate
    }

}

export default InvoiceDueDate





// WEBPACK FOOTER //
// ./src/invoice/duedate.component.jsx